var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-vip-order"},[_c('PaymentMethods',{attrs:{"type":"vip","finalPrice":_vm.finalPrice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }